import { createEnum, requestState } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    downloadByFormBuilderFieldId: createEnum(requestState, 'addendumFile.downloadByFormBuilderFieldId'),
    download: createEnum(requestState, 'addendumFile.download'),
  },
  'addendumFile',
);
